(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["almond-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const pointerMode = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const menus = new Map();
    let resizeFrame;

    const clearTimers = (menu) => {
      window.clearTimeout(menu.openTimer);
      window.clearTimeout(menu.closeTimer);
    };

    const close = (menu) => {
      clearTimers(menu);
      menu.details.open = false;
      menu.summary.setAttribute('aria-expanded', 'false');
    };

    const measure = (menu) => {
      const header = menu.details.closest('.header-wrapper');
      const top = header ? header.getBoundingClientRect().bottom : menu.panel.getBoundingClientRect().top;
      menu.panel.style.setProperty('--almond-nav-top', `${Math.max(0, Math.round(top))}px`);
    };

    const open = (menu) => {
      if (!pointerMode.matches || !menu.details.isConnected) return;
      for (const other of menus.values()) {
        if (other !== menu && other.details.open && other.details.contains(document.activeElement)) return;
      }
      for (const other of menus.values()) if (other !== menu) close(other);
      measure(menu);
      menu.details.open = true;
      menu.summary.setAttribute('aria-expanded', 'true');
    };

    const setup = () => {
      for (const [details, menu] of menus) {
        if (!details.isConnected) {
          clearTimers(menu);
          menus.delete(details);
        }
      }

      document.querySelectorAll('.header__inline-menu header-menu > details.mega-menu').forEach((details) => {
        if (menus.has(details)) return;
        const summary = details.querySelector(':scope > summary');
        const panel = details.querySelector(':scope > .mega-menu__content');
        if (!summary || !panel) return;
        const menu = { details, summary, panel };
        menus.set(details, menu);

        if (panel.querySelector('a[href$="/collections/iphone-cases"]') && panel.querySelector('a[href$="/collections/samsung-phone-cases"]')) {
          details.dataset.almondPhoneMenu = 'true';
        }

        summary.setAttribute('aria-expanded', String(details.open));
        if (panel.id) summary.setAttribute('aria-controls', panel.id);

        details.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !pointerMode.matches) return;
          clearTimers(menu);
          menu.openTimer = window.setTimeout(() => open(menu), 140);
        });

        details.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse' || !pointerMode.matches) return;
          clearTimers(menu);
          menu.closeTimer = window.setTimeout(() => {
            if (!details.contains(document.activeElement)) close(menu);
          }, 240);
        });

        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) measure(menu);
        });
      });
    };

    document.addEventListener('pointerdown', (event) => {
      for (const menu of menus.values()) {
        if (menu.details.open && !menu.details.contains(event.target)) close(menu);
      }
    }, { capture: true });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      for (const menu of menus.values()) {
        if (!menu.details.open) continue;
        const restoreFocus = menu.details.contains(document.activeElement);
        close(menu);
        if (restoreFocus) {
          event.preventDefault();
          menu.summary.focus({ preventScroll: true });
        }
      }
    });

    const updatePositions = () => {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = undefined;
        for (const menu of menus.values()) if (menu.details.open) measure(menu);
      });
    };

    pointerMode.addEventListener('change', () => {
      if (!pointerMode.matches) for (const menu of menus.values()) close(menu);
    });
    window.addEventListener('resize', updatePositions, { passive: true });
    window.addEventListener('scroll', updatePositions, { passive: true });
    document.addEventListener('shopify:section:load', setup);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
    else setup();
  })();
  } catch(e) { console.error(e); }
})();

})();
